import { render, staticRenderFns } from "./FeeSchedule.vue?vue&type=template&id=71a765eb&scoped=true&"
import script from "./FeeSchedule.vue?vue&type=script&lang=js&"
export * from "./FeeSchedule.vue?vue&type=script&lang=js&"
import style0 from "./FeeSchedule.vue?vue&type=style&index=0&id=71a765eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a765eb",
  null
  
)

export default component.exports